/* tslint:disable:no-console */
import { createReportEventUnauthenticatedParams, ReportEventUnauthenticatedParams } from './ReportEventUnauthenticatedParams';
import { FetchRequester } from './FetchRequester';
import { PropertiesType } from './ProductUsageReportBaseEvent';

export class TelemetryForwarder {
  private requester: FetchRequester;

  private static readonly defaultEndpoint: string = '';
  private static readonly podIndex: string = 'pod_name';

  private isVizportal: boolean;

  public constructor(endpoint: string = TelemetryForwarder.defaultEndpoint, isPublicGuest: boolean = false) {
    this.isVizportal = endpoint === TelemetryForwarder.defaultEndpoint;
    this.requester = new FetchRequester(this.getEndpoint(endpoint, isPublicGuest));
  }

  public send(reportEventUnauthenticatedParams: ReportEventUnauthenticatedParams): void {
    this.requester.send(reportEventUnauthenticatedParams);
  }

  public buildTelemetryAndSend(eventType: string, serviceName: string, properties: PropertiesType): void {
    // Vizportal sets the 'pod' property for events sent to it. If we're sending elsewhere,
    // the client needs to set that value itself
    if (!this.isVizportal) {
      properties[TelemetryForwarder.podIndex] = document.domain;
    }

    this.requester.send(createReportEventUnauthenticatedParams(eventType, serviceName, properties));
  }

  private getEndpoint(endpoint: string, isPublicGuest: boolean): string {
    if (!isPublicGuest) {
      return endpoint;
    }
    switch (document.domain) {
      case 'public.tableau.com': {
        return 'https://prod.telemetry.tableausoftware.com';
      }
      case 'public-stage.tableau.com': {
        return 'https://stage.telemetry.tableausoftware.com';
      }
      default: {
        return 'https://qa.telemetry.tableausoftware.com';
      }
    }
  }
}
